import { useMsal } from "@azure/msal-react";
import { AuthHelper } from "../auth/AuthHelper";
import { TokenService } from "../services/TokenService";
import { getErrorDetails } from '../../components/utils/TextUtils';

export const useToken = () => {

    const tokenService = new TokenService();
    const { instance, inProgress } = useMsal();

    const revokeToken = async () => {
        try {
            await tokenService.revokeTokenAsync(await AuthHelper.getSKaaSAccessToken(instance, inProgress));

        } catch (e: unknown) {
            const errorMessage = `Unable to revoke session: ${getErrorDetails(e)}`;
            console.error(errorMessage);
        }
    }

    return {
        revokeToken
    }
}